import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'roomcategorymaster'
})
export class RoomcategorymasterpipePipe implements PipeTransform {

  transform(items: any[], searchText: string) {
    return items ? items.filter(item => item.roomCategory.search(new RegExp(searchText, 'i')) > -1) : [];
    }


}
